import { render, staticRenderFns } from "./ConfirmDeactivationModal.vue?vue&type=template&id=087fb6af&scoped=true"
import script from "./ConfirmDeactivationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeactivationModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeactivationModal.vue?vue&type=style&index=0&id=087fb6af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087fb6af",
  null
  
)

export default component.exports